<template lang="pug">
th.sticky(:style="{ left: offset + 'px' }", :class="{ hover: hover }")
  slot {{ title }}
</template>

<script>
export default {
  name: "StickyColumn",
  props: {
    offset: Number,
    title: String,
    hover: Boolean,
  },
};
</script>

<style lang="scss" scoped>
.sticky {
  position: sticky;
  top: 0;
}
</style>
